// semeia-disable-reexport
export class OnlineConsultationError extends Error {
  state = "notSupported";
}
export class OnlineConsultationNotSupportedError extends Error {
  state = "notSupported";
}
export class OnlineConsultationTokenExpiredError extends Error {
  state = "tokenExpired";
}
export class OnlineConsultationNotAllowedError extends Error {
  state = "notAllowed";
}
export class OnlineConsultationNotFoundError extends Error {
  state = "notFound";
}
export class OnlineConsultationNotReadableError extends Error {
  state = "notReadable";
}
export class OnlineConsultationTypeError extends Error {
  state = "notSecure";
}
